import {NgModule} from '@angular/core';
import {CsConfigPage} from "./page/overview/cs-config-page/cs-config.page";
import {CS_ENTITY_PROVIDER} from "./cs.entity-provider";
import {CoreModule} from "../../core/core.module";
import {CS_TEST_PROVIDERS} from "./test/cs-test-definition";

@NgModule({
  declarations: [
    CsConfigPage,
  ],
  exports:[
  ],
    imports: [
        CoreModule,

    ],
  providers: [CS_ENTITY_PROVIDER, CS_TEST_PROVIDERS]
})
export class CsModule { }
 
 
 
